import { MotionProps, motion } from "framer-motion";
import { useContext } from "react";
import { Popover, PopoverProps } from "react-aria-components";
import { SelectTriggerContext } from "./types";

const MotionPopover = motion(Popover);

type Placement =
  | "bottom"
  | "bottom left"
  | "bottom right"
  | "bottom start"
  | "bottom end"
  | "top"
  | "top left"
  | "top right"
  | "top start"
  | "top end"
  | "left"
  | "left top"
  | "left bottom"
  | "start"
  | "start top"
  | "start bottom"
  | "right"
  | "right top"
  | "right bottom"
  | "end"
  | "end top"
  | "end bottom";

export default function SelectPopover({
  placement = "bottom",
  ...props
}: PopoverProps & MotionProps) {
  const { currentAnimation, onComplete } = useContext(SelectTriggerContext);
  return (
    <MotionPopover
      variants={{
        hidden(placement: Placement) {
          let y = 0;
          if (placement.includes("top")) {
            y = 30;
          } else if (placement.includes("bottom")) {
            y = -30;
          }
          return {
            opacity: 0,
            scale: 0.95,
            y,
            pointerEvents: "none",
            transitionEnd: {
              pointerEvents: "none",
            },
          };
        },
        visible: {
          opacity: 1,
          scale: 1,
          y: 0,
          pointerEvents: "none",
          transitionEnd: {
            pointerEvents: "auto",
          },
        },
      }}
      initial="hidden"
      custom={placement}
      placement={placement}
      animate={currentAnimation}
      transition={{ type: "spring", mass: 0.2, stiffness: 150 }}
      isExiting={currentAnimation === "hidden"}
      onAnimationComplete={onComplete}
      style={{ zIndex: 100000000 }}
      {...props}
    />
  );
}
